/** @format */

module.exports = {
  publicKey: "4C10D9B8326965DE821FA1B8A90653D9",
  hostnameId: "bethard",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js